export default __webpack_public_path__ + "static/transaction-behavior-b0a794ee81063c662309fa5e3d1e9159.png";